import React, { useEffect, useState } from 'react'
import clinicService from '../../services/clinic.service'
import SocialLink from './SocialLink'

const FeedbackSat = ({ clinic }) => {
  const [clinicLinks, setClinicLinks] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    clinicService
      .getLinks(clinic.ID)
      .then((res) => setClinicLinks(res.data || []))
      .catch(() => setClinicLinks([]))
      .finally(() => setLoading(false))
  }, [clinic.ID])

  return (
    <section className="rep-panel">
      <p className="rep-kicker">Thank you</p>
      <h2 className="rep-title">We appreciate your kind words</h2>
      <p className="rep-copy">
        If you have a moment, sharing a quick public review helps other patients
        find the care they need.
      </p>

      {loading ? (
        <div className="rep-spinner" role="status" aria-label="Loading review links" />
      ) : clinicLinks && clinicLinks.length > 0 ? (
        <div className="rep-links">
          {clinicLinks.map((link) => (
            <SocialLink socialLink={link} key={link.ID || link.link} />
          ))}
        </div>
      ) : (
        <p className="rep-copy" style={{ marginBottom: 0 }}>
          Thank you again for your feedback.
        </p>
      )}
    </section>
  )
}

export default FeedbackSat
